import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import ReactGA from 'react-ga'
import ReactGA4 from 'react-ga4'
import { PropTypes } from 'prop-types'

const UA_ID = process.env.REACT_APP_UA_ID
const GA4_ID = process.env.REACT_APP_GA4_ID
ReactGA.initialize(UA_ID)
ReactGA4.initialize(GA4_ID)

/**
 *
 */
class GAListener extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  componentDidMount () {
    this.sendPageView(this.context.router.history.location)
    this.context.router.history.listen(this.sendPageView)
  }

  sendPageView (location) {
    ReactGA.set({ page: location.pathname })
    ReactGA.pageview(location.pathname)
    ReactGA4.send({ hitType: 'pageview', page: location.pathname })
  }

  render () {
    return this.props.children
  }
}

ReactDOM.render(
  <BrowserRouter>
    <GAListener>
      <App />
    </GAListener>
  </BrowserRouter>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js